import styled from 'styled-components'

interface IRightFixedMobileButton {
  height: number
}

export const RightFixedMobileButton = styled.div<IRightFixedMobileButton>`
  position: fixed;
  bottom: calc(30vh - ${props => props.height}px);
  height: ${props => props.height}px;
  width: 32px;
  z-index: 100;
`

export const NextArticleLoader = styled.div`
  position: fixed;
  top: 50%;
  right: 43%;
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #00104a;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 0.5s infinite linear;
  @keyframes l3 {
    to {
      transform: rotate(1turn);
    }
  }
`
